import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import useAuthStore from "../../../store/Auth";
import { useDeleteBuildingById } from "../../../hooks/common/mutation";
import { useTranslation } from "react-i18next";
import { DELETE_STATUSES } from "../../../constants/common";

interface DeleteBuildingModalProps {
  buildingId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteBuildingModal = ({
  buildingId,
  isOpen,
  onOpenChange,
}: DeleteBuildingModalProps) => {
  const {
    mutateAsync: DeleteBuildingById,
    isPending: isDeleteBuildingByIdLoading,
  } = useDeleteBuildingById();

  const { t } = useTranslation();

  const user = useAuthStore((state) => state.user);

  const handleBuildingLocation = useCallback(async () => {
    try {
      if (user?.user_id) {
        const body = {
          encryptedId: buildingId.toString(),
        };

        await DeleteBuildingById(body);
        toast.success(t("buildingDeleted"));
      }
    } catch (error: any) {
      if (error.result.deleteStatus === DELETE_STATUSES.USED_IN_APPOINTMENT) {
        toast.error(t("buildingNotDeletedUsedByAppointment"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [DeleteBuildingById, t, buildingId, onOpenChange, user?.user_id]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteBuilding")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleBuildingLocation}
            isLoading={isDeleteBuildingByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteBuildingModal);
